import { totalPages } from "./../souscategories/souscategorieSlice";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../store";
import ClientType, {
  FideliteTimelineItem,
  HistoriqueFideliteType,
  NiveauFideliteType,
  ZoneType,
} from "../../../Types/Entites/ClientType";

import _ from "lodash";
import { ProgramFideliteType } from "../../../Types/Entites/RemiseType";
import { OrderType } from "../../../Types/Entites/Orders/OrderType";

/**
 * create clients function
 * @private
 */
export const createClientsApi = createAsyncThunk(
  "client/createClientsApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post("client/createClientsApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * create clients function
 * @private
 */
export const createNIveauFidApi = createAsyncThunk(
  "client/createNIveauFid",
  async (data: NiveauFideliteType, { rejectWithValue }) => {
    try {
      const response = await axios.post("client/createNIveauFid", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * create clients function
 * @private
 */
export const createFideliteProgramApi = createAsyncThunk(
  "remises/saveFideliteProg",
  async (data: ProgramFideliteType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveFideliteProg", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

export const updateFideliteApi = createAsyncThunk(
  "remises/updateFideliteApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put("remises/updateFideliteApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const deleteFidelite = createAsyncThunk(
  "remises/deleteFidelite",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(`remises/deleteFidelite/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * Get list of clients.
 * @public
 */
export const findClientBySocieteApi = createAsyncThunk(
  "client/findClientBySocieteApi",
  async (
    {
      id,
      page,
      limit,
      search = "",
    }: { id: string; page: number; limit: number; search?: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await axios.get(
        `client/findClientBySocieteApi/${id}?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search,
        )}`,
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response?.data?.message || "Erreur de chargement",
      });
    }
  },
);

/**
 * Get list of clients.
 * @public
 */
export const findNiveauxFidelite = createAsyncThunk(
  "client/findNiveauxFidelite",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`client/findNiveauxFidelite/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

/**
 * Get list of clients.
 * @public
 */
export const findZonesByOrganisation = createAsyncThunk(
  "client/findZones",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`client/findZones/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

/**
 * Get list of clients.
 * @public
 */
export const findFidelitePrograms = createAsyncThunk(
  "remises/findProgFidelite",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`remises/findProgFidelite/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  },
);

/**
 * update tables function
 * @private
 */
export const updateClientApi = createAsyncThunk(
  "client/updateClientApi",
  async (data: Partial<ClientType>, { rejectWithValue }) => {
    try {
      const response = await axios.put("client/updateClientApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * update tables function
 * @private
 */
export const updateNIveauFidApi = createAsyncThunk(
  "client/updateNIveauFid",
  async (data: Partial<ClientType>, { rejectWithValue }) => {
    try {
      const response = await axios.put("client/updateNIveauFid", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * desactive client function
 * @private
 */
export const desactiveClientApi = createAsyncThunk(
  "client/desactiveClientApi",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.put(`client/desactiveClientApi/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const activeClientApi = createAsyncThunk(
  "client/activeClientApi",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.put(`client/activeClientApi/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const blockClientApi = createAsyncThunk(
  "client/blockClient",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.put(`client/blockClient/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const findClientByBarcode = createAsyncThunk(
  "client/findClientByBarcode",
  async (barcode: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`client/findClientByBarcode/${barcode}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const findClientById = createAsyncThunk(
  "client/findClientById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`client/findClientById/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const deleteNiveauClient = createAsyncThunk(
  "client/deleteNiveauClientApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `client/deleteNiveauClientApi/${data.id}/${data.societeID}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
/**
 * active client function
 * @private
 */
export const findClientByMobile = createAsyncThunk(
  "client/findClientByMobile",
  async (mobile: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`client/findClientByMobile/${mobile}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

// *************************************** FIDELITE *************************************************

export const createProgramFidelite = createAsyncThunk(
  "fidelite/saveFideliteProg",
  async (data: ClientType, { rejectWithValue }) => {
    try {
      const response = await axios.post("fidelite/saveFideliteProg", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

export const createHistoriqueFidelite = createAsyncThunk(
  "client/saveHistory",
  async (data: HistoriqueFideliteType, { rejectWithValue }) => {
    try {
      const response = await axios.post("client/saveHistory", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const findClientHistoriqueFidelite = createAsyncThunk(
  "client/findClientHistorique",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`client/findClientHistorique/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);

/**
 * active client function
 * @private
 */
export const findClientOrders = createAsyncThunk(
  "client/findClientOrders",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`client/findClientOrders`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  },
);
export const getClientFideliteTimeline = createAsyncThunk(
  "client/getFideliteTimeline",
  async (clientId: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`client/fideliteTimeline/${clientId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response?.data?.message || "Erreur de chargement",
      });
    }
  },
);
interface ClientState {
  listClients: ClientType[];
  ListClientsGroupedByBarcode: { [barcode: string]: ClientType[] };
  listFidelitePrograms: ProgramFideliteType[];
  ListNiveauxFidelite: NiveauFideliteType[];
  listZones: ZoneType[];
  historiqueFideliteByOrder: { [order: string]: HistoriqueFideliteType[] };
  clientOrdersList: any;
  totalPages: number;
  currentPage: number;
  totalClients: number;
  historiqueFidelite: HistoriqueFideliteType[];
  ClientOrdersList: OrderType[];
  searchKeyword: string;
  isInitialized: boolean;
  fideliteTimeline: {
    timeline: FideliteTimelineItem[];
    totalEarned: number;
    totalSpent: number;
    currentBalance: number;
    loading: boolean;
  };
}

const initialState: ClientState = {
  ListClientsGroupedByBarcode: {},
  listFidelitePrograms: [],
  ListNiveauxFidelite: [],
  listZones: [],
  historiqueFideliteByOrder: {},
  clientOrdersList: {},
  listClients: [] as ClientType[],
  totalPages: 1,
  currentPage: 1,
  totalClients: 0,
  historiqueFidelite: [],
  ClientOrdersList: [],
  searchKeyword: "",
  isInitialized: false,
  fideliteTimeline: {
    timeline: [],
    totalEarned: 0,
    totalSpent: 0,
    currentBalance: 0,
    loading: false,
  },
};

export const ClientSlice = createSlice({
  name: "clientSlice",
  initialState,
  reducers: {
    setSearchKeyword: (state, action) => {
      state.searchKeyword = action.payload;
    },
    resetClientState: (state) => {
      state.listClients = [];
      state.ListNiveauxFidelite = [];
      state.currentPage = 1;
      state.totalPages = 1;
      state.searchKeyword = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createClientsApi.fulfilled, (state, action) => {
      state.listClients.splice(0, 0, action.payload.data);
    });
    builder.addCase(createNIveauFidApi.fulfilled, (state, action) => {
      state.ListNiveauxFidelite.splice(0, 0, action.payload.data);
    });

    builder.addCase(findClientBySocieteApi.fulfilled, (state, action) => {
      state.listClients = action.payload.clients || [];
      state.totalPages = action.payload.totalPages || 1;
      state.currentPage = action.payload.currentPage || 1;
      state.totalClients = action.payload.totalClients || 0;
      state.isInitialized = true;
    });

    builder.addCase(findClientHistoriqueFidelite.fulfilled, (state, action) => {
      const groupedByOrder = _.groupBy(action.payload, "order_id");
      return {
        ...state,
        historiqueFideliteByOrder: groupedByOrder,
      };
    });
    builder.addCase(findClientOrders.fulfilled, (state, action) => {
      return {
        ...state,
        clientOrdersList: action.payload,
      };
    });

    builder.addCase(findNiveauxFidelite.fulfilled, (state, action) => {
      return {
        ...state,
        ListNiveauxFidelite: action.payload,
      };
    });
    builder.addCase(findZonesByOrganisation.fulfilled, (state, action) => {
      return {
        ...state,
        listZones: action.payload,
      };
    });
    builder.addCase(findFidelitePrograms.fulfilled, (state, action) => {
      return {
        ...state,
        listFidelitePrograms: action.payload,
      };
    });

    builder.addCase(updateFideliteApi.fulfilled, (state, action) => {
      const findindex = state.listFidelitePrograms.findIndex(
        (item) => item._id === action.payload.data.updatefidelite._id,
      );
      if (findindex !== -1) {
        state.listFidelitePrograms[findindex] =
          action.payload.data.updatefidelite;
      }
    });

    builder.addCase(updateClientApi.fulfilled, (state, action) => {
      const updatedClient = action.payload.data;
      const index = state.listClients.findIndex(
        (client) => client._id === updatedClient._id,
      );
      if (index !== -1) {
        state.listClients[index] = updatedClient;
      }
    });
    builder.addCase(updateNIveauFidApi.fulfilled, (state, action) => {
      const updatedClient = action.payload.data;
      const index = state.ListNiveauxFidelite.findIndex(
        (client) => client._id === updatedClient._id,
      );
      if (index !== -1) {
        state.ListNiveauxFidelite[index] = updatedClient;
      }
    });
    builder.addCase(deleteNiveauClient.fulfilled, (state, action) => {
      const deleted = action.payload.data;
      state.ListNiveauxFidelite = _.remove(state.ListNiveauxFidelite, {
        _id: deleted._id,
      });
    });
    builder.addCase(deleteFidelite.fulfilled, (state, action) => {
      const deleted = action.payload.data.deletedFidelite;
      console.log(action)
      state.listFidelitePrograms = _.remove(state.listFidelitePrograms, {
        _id: deleted._id,
      });
    });
    builder.addCase(desactiveClientApi.fulfilled, (state, action) => {
      const updatedClient = action.payload.data;
      const index = state.listClients.findIndex(
        (client) => client._id === updatedClient._id,
      );
      if (index !== -1) {
        state.listClients[index] = updatedClient;
      }
    });
    builder.addCase(activeClientApi.fulfilled, (state, action) => {
      const updatedClient = action.payload.data;
      const index = state.listClients.findIndex(
        (client) => client._id === updatedClient._id,
      );
      if (index !== -1) {
        state.listClients[index] = updatedClient;
      }
    });
    builder.addCase(getClientFideliteTimeline.pending, (state) => {
      state.fideliteTimeline.loading = true;
    });
    builder.addCase(getClientFideliteTimeline.fulfilled, (state, action) => {
      state.fideliteTimeline.loading = false;
      state.fideliteTimeline.timeline = action.payload.data.timeline;
      state.fideliteTimeline.totalEarned = action.payload.data.totalEarned;
      state.fideliteTimeline.totalSpent = action.payload.data.totalSpent;
      state.fideliteTimeline.currentBalance =
        action.payload.data.currentBalance;
    });
    builder.addCase(getClientFideliteTimeline.rejected, (state) => {
      state.fideliteTimeline.loading = false;
      state.fideliteTimeline.timeline = [];
    });
  },
});

export const { setSearchKeyword, resetClientState } = ClientSlice.actions;

export const ListClient = (state: RootState) => state.clients.listClients;
export const ListZones = (state: RootState) => state.clients.listZones;
export const ListNiveauxFidelite = (state: RootState) =>
  state.clients.ListNiveauxFidelite;
export const ListProgramFidelite = (state: RootState) =>
  state.clients.listFidelitePrograms;
export const ListClientBuBarcode = (state: RootState) =>
  state.clients.ListClientsGroupedByBarcode;
export const historiqueFidelite = (state: RootState) =>
  state.clients.historiqueFideliteByOrder;
export const clientOrders = (state: RootState) =>
  state.clients.clientOrdersList;
export const getSearchKeyword = (state: RootState) =>
  state.clients.searchKeyword;
export const getIsInitialized = (state: RootState) =>
  state.clients.isInitialized;

export default ClientSlice.reducer;
